module.exports = __webpack_public_path__ + "media/images/logo_claim_300dpi_rgb-0f9a332a.jpg";